export const environment = {
    production: true,
    baseUrl: '/',
    mainUrl: 'https://orthocomm.en-pc.tokyo/',
    apiUrl: '/api/v1.0.0',
    imageUrl: '/image/v1.0.0/redirect/',
    imageRedirectUrl: '/image/v1.0.0/redirect',
    imageStatusUrl: '/image/v1.0.0/status',
    tokenDeviceUrl: '/client/activation/',
    versionApp: '1.0.1',
    versionWeb: 'v2.1.0',
    versionApi: 'v1.0.0',
    senderID: 115591774822,
    gmo: {
        callbackUrl: "https://orthocomm.en-pc.tokyo/api/v1.0.0/payment/registered-card"
    },
    toolUploadUrl: 'https://tokyo.orthocomm.net/photosend/',
    toolUpdateProfileUrl: 'https://tool.orthocomm.net/proftokyo/',
    device: {
        androidStoreUrl: 'https://play.google.com/store/apps/details?id=net.orthocomm.app',
        iosStoreUrl: 'https://itunes.apple.com/us/app/orthocomm-aligner-management/id1210249737?mt=8',
        urlScheme: 'tokyoorthocomm://orthocomm.en-pc.tokyo'
    },
    vapidPublicKey: "BI2vsW3w5zcMWQjLOIbIiwTJlSSxPCrPVBNdZfPBx6x7kPv8EIXHkH8nM-XNsO1_0YRQecKOm1YCPpKhJ8RXLEg"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts